// Аналог uuid для Node.js, который на клиенте не работает, поэтому пишем сами.
// Приводится к строке и отправляется на клиент, исполняется уже на клиенте.
export function uuidv4() {
    return ('10000000-1000-4000-8000-100000000000')
        .replace(
            /[018]/g,
            c => (Number(c) ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> Number(c) / 4).toString(16),
        );
}
